var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-property-lookup", attrs: { id: _vm.id } },
    [
      _c("div", { staticClass: "c-property-lookup__group" }, [
        _c(
          "div",
          { staticClass: "c-property-lookup__lookup" },
          [
            _vm.label
              ? _c("label", { staticClass: "c-property-lookup__label" }, [
                  _vm._v(_vm._s(_vm.label) + "\n      ")
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.lookupDisabled
              ? _c(
                  "form",
                  {
                    staticClass: "c-property-lookup__form",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.onPropertyLookup($event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "c-form__group" },
                      [
                        _c(
                          "validation-message",
                          {
                            attrs: {
                              valid: _vm.touched["search"] && _vm.searchIsValid,
                              invalid:
                                _vm.touched["search"] && !_vm.searchIsValid,
                              validationMessage: _vm.getValidationMessage
                            }
                          },
                          [
                            _c("text-field", {
                              key: _vm.getFieldId,
                              attrs: {
                                type: "search",
                                label: _vm.lookupLabel,
                                id: _vm.getFieldId,
                                value: _vm.field
                              },
                              on: {
                                input: _vm.onSearchInput,
                                submit: _vm.onPropertyLookup,
                                change: _vm.onSearchChange
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "c-property-lookup__button",
                        class: { "is-loading": _vm.loading },
                        attrs: { type: "submit", disabled: _vm.loading }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.searchButton) +
                            "\n          "
                        ),
                        _vm.loading
                          ? _c("div", { staticClass: "c-spinner" }, [
                              _c("div"),
                              _vm._v(" "),
                              _c("div"),
                              _vm._v(" "),
                              _c("div")
                            ])
                          : _vm._e()
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "collapsible-container",
              [
                _c(
                  "collapsible-container-content",
                  {
                    attrs: {
                      title: "Select address",
                      index: "0",
                      isOpen: _vm.selectAddressContainerIsOpen
                    }
                  },
                  [
                    _c(
                      "validation-message",
                      {
                        attrs: {
                          valid: _vm.locationIsValid,
                          invalid:
                            _vm.address.value.length > 0 &&
                            !_vm.locationIsValid,
                          validationMessage: _vm.getLocationInvalidMessage
                        }
                      },
                      [
                        _c("select-dropdown", {
                          attrs: {
                            id: "selectAddress",
                            label: "Select address",
                            options: _vm.availableAddresses
                          },
                          on: { change: _vm.onSelectAddressChange },
                          model: {
                            value: _vm.address.value,
                            callback: function($$v) {
                              _vm.$set(_vm.address, "value", $$v)
                            },
                            expression: "address.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43168d80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43168d80","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/property-lookup/PropertyLookup.vue
// module id = 697
// module chunks = 0